



































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ModalWrapper from '@/components/shared/modals/ModalWrapper.vue';
import BalanceInput from '@/components/shared/BalanceInput.vue';
import exec from '@/utils/transactionExecutor';
import { notificationTypes, showNotification } from '@/utils/notification';
import { KeyringPair } from '@polkadot/keyring/types';
import { rewardDestinationOptions } from '../constants';

import Connector from '@vue-polkadot/vue-api';

const components = {
  ModalWrapper,
  BalanceInput
};

@Component({ components })
export default class SetRewardDestination extends Vue {
  @Prop() public stashId!: string;
  @Prop() public controllerId!: string;
  
  private account: string = '';
  private password: string = '';
  private destination: number = 0;

  get options() {
    return rewardDestinationOptions;
  }

  get callback() {
    const { api } = Connector.getInstance();
    return api.tx.staking.setPayee;
  }

  get params() {
    return [this.destination];
  }

  get disabled() {
    return false;
  }

    public handleAccountSelection(account: KeyringPair) {
    this.account = account.address;
  }

  private async submit() {
       try {
      const { stashId: account, password, callback, params } = this;
      showNotification(`Dispatched`);
      console.log(params);
      const tx = await exec(account, password, callback, params);
      showNotification(tx, notificationTypes.success);
      console.log(`[SetControllerAccount] ${tx}`);
    } catch (e) {
      showNotification(e.message , notificationTypes.danger);
      console.error(e)
    }

  }
}
